import React, { useId } from "react";
import { twMerge } from "tailwind-merge";
import { lgvInputClassName } from "./lgvFieldStyles";

export interface LgvTextFieldProps {
  id?: string;
  name?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  className?: string;
  type?: "text" | "number" | "email";
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  maxLength?: number;
  autoComplete?: string;
  multiline?: boolean;
  rows?: number;
  min?: string | number;
  max?: string | number;
  step?: string | number;
}

const LgvTextField: React.FC<LgvTextFieldProps> = ({
  id,
  name,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder,
  className,
  type = "text",
  inputMode,
  maxLength,
  autoComplete,
  multiline = false,
  rows = 4,
  min,
  max,
  step,
}) => {
  const generatedId = useId();
  const fieldId = id ?? generatedId;
  const inputClassName = lgvInputClassName(disabled, className);

  if (multiline) {
    return (
      <textarea
        id={fieldId}
        name={name}
        value={value}
        rows={rows}
        disabled={disabled}
        required={required}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        className={twMerge(inputClassName, "resize-y min-h-[6rem]")}
      />
    );
  }

  return (
    <input
      id={fieldId}
      name={name}
      type={type}
      value={value}
      disabled={disabled}
      required={required}
      placeholder={placeholder}
      min={min}
      max={max}
      step={step}
      inputMode={inputMode}
      maxLength={maxLength}
      autoComplete={autoComplete}
      onChange={(event) => onChange(event.target.value)}
      className={inputClassName}
    />
  );
};

export default LgvTextField;
